/**
 * Press cards for the US homepage, in grid order: two rows of three. Quotes
 * live in i18n (`homepage.ringProUs.press.items.<id>`) and are verbatim from
 * the linked review; each was checked against the live article on Oct 27
 * 2026. Do not edit a quote without re-checking it.
 */
export type PressOutlet =
  | 'techAdvisor'
  | 'trustedReviews'
  | 'engadget'
  | 'wareable'
  | 'yahooTech';

export type PressItem = {
  id: string;
  outlet: PressOutlet;
  href: string;
};

export const PRESS_ITEMS: readonly PressItem[] = [
  {
    id: 'engadgetCase',
    outlet: 'engadget',
    href: 'https://www.engadget.com/2172740/ultrahuman-ring-pro-review/',
  },
  {
    id: 'trustedReviewsBattery',
    outlet: 'trustedReviews',
    href: 'https://www.trustedreviews.com/reviews/ultrahuman-ring-pro',
  },
  {
    id: 'techAdvisorVerdict',
    outlet: 'techAdvisor',
    href: 'https://www.techadvisor.com/article/3170046/ultrahuman-ring-pro-review.html',
  },
  {
    id: 'wareableStamina',
    outlet: 'wareable',
    href: 'https://www.wareable.com/wearable-tech/ultrahuman-ring-pro-review',
  },
  {
    id: 'trustedReviewsMembership',
    outlet: 'trustedReviews',
    href: 'https://www.trustedreviews.com/reviews/ultrahuman-ring-pro',
  },
  {
    /* Matt Kollat's T3 review, as syndicated on Yahoo Tech. */
    id: 'yahooTechData',
    outlet: 'yahooTech',
    href: 'https://tech.yahoo.com/wearables/articles/wore-ultrahuman-ring-pro-month-050000403.html',
  },
];
